import {
  ScheduleValidationData,
  Phase,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'

export const noIncompatibleMinimumProration =
  (ctx: { phaseId: Phase['id'] }) =>
  (prevState: ScheduleValidationData): ValidationResult[] | null => {
    const thisPhase = prevState.queries.resolvedPhases[ctx.phaseId]

    if (thisPhase.analysis?.proration.invalidMinimums.length) {
      return [
        {
          message:
            'Phase contains minimums which are updated in the middle of a billing period.',
          metadata: {
            invalidMinimums: thisPhase.analysis?.proration.invalidMinimums
          }
        }
      ]
    }

    return null
  }
